<template>
	<div>
		<Header :isHome="false"></Header>
		
		<div class="container" v-if="data">
			<div class="news row">
				<div class="news-left col-8">
					<div class="news-top">
						<span style="cursor: pointer;" class="line-title" @click="toHome">Home</span><span class="news-top-icon">></span>
						<span style="cursor: pointer;" class="line-title" @click="tonewsmain">Information</span><span class="news-top-icon">></span>
						<span>{{data.classify.title}}</span>
					</div>
					<div style="margin-top: 1rem;" class="news-title">
						<!-- {{data.title}} -->
					</div>
					
					<div class="news-left-box-r">
						<div class="news-left-box-r-title">{{data.title}}</div>
						<div class="news-left-box-r-tags">
							<div v-for="(tag, index3) in data.tags" :key="index3" style="margin-right: 0.5rem;" :style="{color: colorlist[index3]}">{{tag.name}} .</div>
						</div>
						<div style="display: flex;align-items: center;margin-top: 0.5rem;">
							<!-- <img src="../../assets/imgs/news/icon-time.png" class="news-left-box-r-icon"> -->
							<div style="flex: 1;display: flex;align-items: center;">
								<span class="news-left-box-r-icontext">{{data.createdAt|format}}</span>
							</div>
							<!-- fackbook -->
							<img src="@/assets/imgs/footer-icon-1.png" alt="" style="margin-right: 0.5rem;cursor: pointer;" class="news-left-box-r-icon" @click="openurl('facebook')">
							<!-- twitter -->
							<img src="@/assets/imgs/footer-icon-2.png" alt="" style="margin-right: 1rem;cursor: pointer;" class="news-left-box-r-icon" @click="openurl('twitter')">
							<img src="../../assets/imgs/news/icon-eyes.svg" class="news-left-box-r-icon">
							<span class="news-left-box-r-icontext">{{data.browseCount}}</span>
							<img style="cursor: pointer;" :src="data.collected?require('../../assets/imgs/news/icon-star-light.svg'):require('../../assets/imgs/news/icon-star.svg')" class="news-left-box-r-icon" @click="collect()">
							<span class="news-left-box-r-icontext" v-text="data.collectionCount"></span>
							<img style="cursor: pointer;" :src="data.liked?require('../../assets/imgs/news/icon-like-light.svg'):require('../../assets/imgs/news/icon-like.svg')" class="news-left-box-r-icon" @click="like()">
							<span class="news-left-box-r-icontext" v-text="data.likeCount"></span>
							<!-- <span class="news-left-box-r-time">News | mar.29,2023</span> -->
						</div>
						<div v-html="data.content" style="margin-top: 1rem;user-select:none;" ref="el"></div>
						<!-- <div style="margin-top: 1rem;" class="chatbox">
							<input type="text" class="chatbox-input" placeholder="Enter the text you want to enter" @keyup.enter="submitcomment" v-model="comment">
						</div> -->
						
						<div style="margin-top: 1rem;">
							<div class="chatbox" style="border-radius: 0.3rem;">
								<textarea class="chatbox-input" cols="30" rows="10" placeholder="add comment..." v-model="comment"
								style="height: 5rem;"></textarea>
							</div>
							<div style="display: flex;align-items: center;justify-content: flex-end;">
								<button style="margin-top: 1rem; border: none;background-color: #23eae4;padding: 0.5rem 1rem;color: #000;border-radius: 0.5rem;cursor: pointer;" @click="submitcomment(item)">
									submit
								</button>
							</div>
						</div>
						<div class="" style="margin: 3rem 0;">
							<Comment :type="0" :id="id" :commentreload="commentreload"></Comment>
						</div>
					</div>
				</div>
				<Hotnews></Hotnews>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	
			// import axios from 'axios'
			import Header from '/src/components/header.vue'
			import Footer from '/src/components/footer.vue'
			import Hotnews from '/src/components/news/hotnews.vue'
			// import {baseUrl} from '../../assets/js/public.js'
			import Comment from '/src/components/comment.vue'
			export default {
				data() {
					return {
						id:'',
						colorlist:['#01A587', '#8D66F8', '#ED532B', '#D8BE50', '#52A5F7'],
						data: null,
						page: 1,
						perPage: 2,
						comment: '',
						commentdata:[],
						commentreplycontent:'',
						commentreplyid:'',
						headers:{},
						islogin:false,
						showchildrenid: null,
						total:0,
						commentreload:0
					}
				},
				props:{
				},
				components: {
					Header,
					Footer,
					Hotnews,
					Comment
				},
				filters: {
				},
				methods: {
					openurl(type){
						if(type=='twitter'){
							let nowurl = encodeURIComponent(window.location.href)
							let url = 'https://twitter.com/intent/tweet?text='+this.data.profile+'&url='+nowurl
							window.open(url)
						}else{
							window.open('http://www.facebook.com/sharer.php?u='+encodeURIComponent(window.location.href),'sharer','toolbar=0,status=0,width=626,height=436');
						}
					},
					showchildren(item){
						this.showchildrenid = item.id
					},
					collect(){
						this.$bus.$emit('noloading', true)
							let params = {
								articleId:this.data.id
							}
							this.request({
								method: 'post',
								url: '/gci/article/collection',
								data:params
							}).then(res => {
								if(res.status == 0){
									// this.getData()
									if(this.data.collected){
										this.data.collectionCount--
									}else{
										this.data.collectionCount++
									}
									this.data.collected = !this.data.collected
								}else{
									// alert(res.msg)
								}
							}).catch(error => {
								console.error(error.response)
							})
					},
					like(){
						this.$bus.$emit('noloading', true)
							let params = {
								articleId:this.data.id
							}
							this.request({
								method: 'post',
								url: '/gci/article/like',
								data:params
							}).then(res => {
								if(res.status == 0){
									// this.getData()
									if(this.data.liked){
										this.data.likeCount--
									}else{
										this.data.likeCount++
									}
									this.data.liked = !this.data.liked
								}else{
									// alert(res.msg)
								}
							}).catch(error => {
								console.error(error.response)
							})
						
					},
					submitcomment(){
						if(this.comment == ''){
							// alert('comment not empty')
							this.$bus.$emit('message', {
								type:1,
								msg:'comment not empty'
							})
						}else{
							let params = {
								articleId: this.id,
								content: this.comment
							}
							this.request({
								method: 'post',
								url: '/gci/article/comment',
								data:params
							}).then(res => {
								if(res.status == 0){
									this.comment = ''
									this.commentdata = []
									// this.getcommentdata()
									this.commentreload++
								}
								// alert(res.msg)
							}).catch(error => {
								console.error(error.response)
							})
						}
					},
					getData(){
						this.request({
							method: 'get',
							url: '/gci/article/get?articleId=' + this.id,
						}).then(res => {
							this.data = res.data
							this.$bus.$emit('loading', false)
							
							this.$nextTick(()=>{
								const el = this.$refs.el
								el.addEventListener('contextmenu', this.handleRightClick)
							})
						}).catch(error => {
							console.error(error.response)
						})
					},
					toHome(){
						this.$router.push({name:'home'})
					},
					tonewsmain(){
						this.$router.push({name:'newsmain'})
					},
					tonewsdetail(id){
						this.$router.push({name:'newsdetail',params:{id:id}})
					},
					handleRightClick (event) {
						event.preventDefault()
					}
				},
				created() {
					this.$bus.$emit('laoding', true)
				},
				mounted() {
					let token = localStorage.getItem('token')
					if(token){
						this.islogin = true
						this.headers = {authorization:localStorage.getItem('token')}
					}
					this.id = this.$route.query.id
					this.getData()
					// this.getcommentdata()
				}
			}
</script>

<style scoped lang="scss">
	.line-title:hover{
		color: #62e0c9;
	}
	.comment-reply{
		font-size: 1rem;
	}
	.comment-reply:hover{
		color: #62e0c9;cursor: pointer;
	}
	.comment-name{
		font-size: 1rem;font-weight: bold;
	}
	.comment-tag{
		font-size: 0.7rem;margin-right: 0.5rem;
	}
	.comment-avatar{
		background-position: center;background-repeat: no-repeat;background-size: cover;
		width: 2.5rem;height: 2.5rem;border-radius: 50%;margin-right: 0.5rem;
	}
	.news-comment-icon{
		width:1rem;height: 1rem;margin-right: 0.5rem;
	}
	.news{
		display: flex;
		margin-top: 7rem;
		.news-left{
			display: flex;flex-direction: column;
			.news-top{
				color: #1C1F24;
				font-size: 1rem;
				font-weight: 500;
				&-icon{
					margin: 0 0.5rem;
				}
			}
		}
	}
	
	.news-left-box-r{
		display: flex;flex-direction: column;max-width: 43rem;
		border-bottom: 1px solid #F4F4F4;padding-bottom: 1rem;
		&-title{
			font-size: 1.5rem;
			font-weight: bold;
			color: #333;
		}
		&-dec{
			font-size: 0.7rem;
			font-weight: 400;
			color: #666;
			margin-top: 0.5rem;
		}
		&-tags{
			font-size: 0.7rem;
			margin-top: 0.5rem;
			display: flex;
			flex-wrap: wrap;
		}
		&-icon{
			width: 1.5rem;height: 1.5rem;margin-right: 0.2rem;
		}
		&-icontext{
			font-size: 0.7rem;color: #666;margin-right: 1rem;
		}
		&-time{
			font-size: 0.7rem;
			color: #999;
			font-weight: 400;
		}
	}
	.chatbox{
		border: 1px solid #DFDFDF;
		padding: 0.5rem;
		.chatbox-input{
			border: none;
			width:100%
		}
	}
	
	.loadmorereply{
		color: #333;cursor: pointer;
	}
	.loadmorereply:hover{
		color: #31ffda;
	}
	@media (max-width:767px) {
		.news-left{
			min-width: 100%;
		}
		.news-left-box-r-tags{
			font-size: 0.7rem;
		}
		.news-left-box-r-icontext{
			font-size: 0.7rem;
			// font-weight: bold;
		}
		.news-left-box-r-icon{
			width:1.2rem;height: 1.2rem;
		}
	}
</style>